import React, { Component } from 'react';
import { Chart } from 'primereact/chart';

class BarChart extends Component {
    constructor(props) {
        super(props);
        var data = JSON.parse(this.props.values);

        this.state = {
            data: data
        };
    }

    render() {
        const basicOptions =  {
                legend: {
                    labels: {
                        fontColor: '#495057'
                    }
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontColor: '#495057'
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            fontColor: '#495057'
                        }
                    }]
                }
        };

        return (
            <div className="card">
                <Chart type="bar" data={this.state.data} options={basicOptions} />
            </div>
        )
    }
}

export default BarChart;